import Bugsnag from '@bugsnag/browser';
import BugsnagPluginReact from '@bugsnag/plugin-react';
import React from 'react';
import styled from 'styled-components';
let bugsnagClient = null;
try {
    bugsnagClient = Bugsnag.start({
        apiKey: process.env.MIX_BUGSNAG_API_KEY,
        releaseStage: process.env.MIX_APP_ENV,
        plugins: [new BugsnagPluginReact(React)],
        onError: (event) => {
            // Do not send if no key is set
            if (!process.env.MIX_BUGSNAG_API_KEY) {
                return false;
            }
            if (event.errors[0]?.errorMessage === 'Network Error') {
                return false;
            }
        },
    });
}
catch (e) { }
export const notifyError = (error) => {
    if (bugsnagClient) {
        bugsnagClient.notify(error);
    }
};
export const ErrorBoundary = bugsnagClient?.getPlugin('react')?.createErrorBoundary(React) ||
    styled.div ``;
